import { Controller } from "@hotwired/stimulus"

/**
 * Mobile Navigation Controller
 * 
 * Automatically closes the mobile navigation when navigation links are clicked.
 * This provides a better mobile UX by closing the nav after the user selects a link.
 * 
 * Usage: Add data-controller="mobile-nav" to navigation links that should close the mobile nav
 */
export default class extends Controller {
  connect() {
    this.handleClick = this.handleClick.bind(this)
    this.element.addEventListener('click', this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleClick)
  }

  handleClick() {
    // Close the mobile navigation by removing the 'show' class
    const mobileNav = document.getElementById('topNavbar')
    if (mobileNav) {
      mobileNav.classList.remove('show')
    }
  }
}
